/** The sheet body's non-list states. */

import type { Component } from 'solid-js';
import { Back } from '../icons/nav.tsx';
import styles from './SheetStates.module.css';

/* Named for what it draws, not for what it means: `Loading` is Solid's own
   boundary now, and this is what one of them falls back to. */
export const Spinner: Component = () => <div class={styles.spinner} />;

export interface EmptyProps {
  title: string;
  body: string;
}

export const Empty: Component<EmptyProps> = (props) => (
  <div class={styles.empty}>
    <strong>{props.title}</strong>
    {props.body}
  </div>
);

export interface BackRowProps {
  label: string;
  onClick: () => void;
}

export const BackRow: Component<BackRowProps> = (props) => (
  <button
    type="button"
    data-testid="back-row"
    class={styles.backrow}
    onClick={() => props.onClick()}
  >
    <Back />
    <span>{props.label}</span>
  </button>
);
